import clsx from "clsx";
import Styles from "./index.module.scss";
import { Table } from "react-bootstrap";
import { BsBox2Fill } from "react-icons/bs";

export const AdminTable = ({ columns, data }) => {
  return (
    <>
      {data.length !== 0 ? (
        <Table
          className={clsx(Styles.mainWrap)}
          striped
          bordered
          hover
          variant="light"
        >
          <thead className={clsx(Styles.responsiveTable)}>
            <tr className={clsx(Styles.tableHeader)}>
              {columns.map((column, index) => (
                <th
                  className={clsx(
                    Styles.itemHeader,
                    !column.key && Styles.fitContent
                  )}
                  key={index}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={clsx(Styles.tableBody)}>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} className={clsx(Styles.tr)}>
                {columns.map((column, colIndex) => (
                  <td
                    className={clsx(
                      Styles.itemBody,
                      !column.key && Styles.fitContent
                    )}
                    key={colIndex}
                  >
                    {column.render ? column.render(row) : row[column.key] ?? ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div className={clsx(Styles.mainWrap)}>
          <div className={clsx(Styles.emptyBox)}>
            <BsBox2Fill className={clsx(Styles.iconEmpty)} />
            <span className={clsx(Styles.titleEmpty)}>Dữ Liệu Rỗng</span>
          </div>
        </div>
      )}
    </>
  );
};
